import React, { useCallback } from "react";
import { useDispatch } from "react-redux";

import { setEulaFooterHeight } from "../../../store/layout";
import { EulaBanner } from "../eulaBanner";

import "./EulaFooter.scss";

export const EulaFooter = () => {
  const dispatch = useDispatch();

  const handleHeightChange = useCallback(
    (height: number): void => {
      dispatch(setEulaFooterHeight(height));
    },
    [dispatch]
  );

  return (
    <EulaBanner
      className="eula-footer"
      contentId="eulaFooterText"
      onHeightChange={handleHeightChange}
    />
  );
};
